export const GET_PAYMENTS = "GET_PAYMENTS";
export const GET_PAYMENT = "GET_PAYMENT";
export const ADD_PAYMENT = "ADD_PAYMENT";
export const DELETE_PAYMENT = "DELETE_PAYMENT";
export const UPDATE_PAYMENT = "UPDATE_PAYMENT";
